import { Link } from "react-router-dom";
import { Phone, Mail, ArrowUpRight } from "lucide-react";
import { CONTACT } from "../data";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-[#050507] border-t border-white/10">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <div className="overline text-gold mb-6">{CONTACT.brand}</div>
          <h2 className="font-serif text-4xl md:text-5xl leading-tight tracking-tight max-w-xl">
            Let's win your next <span className="italic text-gold">commercial contract</span>.
          </h2>
          <Link
            to="/contact"
            data-testid="footer-cta"
            className="inline-flex items-center gap-2 mt-8 bg-gold text-black overline px-8 py-4 hover:bg-[#F3E5AB] transition-colors"
          >
            Book a Free Consultation <ArrowUpRight size={16} />
          </Link>
        </div>

        <div className="md:col-span-3">
          <div className="overline text-white/40 mb-5">Navigate</div>
          <ul className="space-y-3 text-white/70">
            <li><Link to="/" className="hover:text-gold transition-colors">Home</Link></li>
            <li><Link to="/services" className="hover:text-gold transition-colors">Services</Link></li>
            <li><Link to="/about" className="hover:text-gold transition-colors">About</Link></li>
            <li><Link to="/contact" className="hover:text-gold transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="overline text-white/40 mb-5">Get in touch</div>
          <ul className="space-y-4 text-white/70">
            <li>
              <a href={`tel:${CONTACT.phone}`} data-testid="footer-phone" className="flex items-center gap-3 hover:text-gold transition-colors">
                <Phone size={16} className="text-gold" /> {CONTACT.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="flex items-center gap-3 hover:text-gold transition-colors break-all">
                <Mail size={16} className="text-gold" /> {CONTACT.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-white/40 text-sm">
        <span>© {new Date().getFullYear()} {CONTACT.brand}. All rights reserved.</span>
        <span>Commercial Contract Acquisition · Lead Generation · AI Automations</span>
      </div>
    </div>
  </footer>
);
